import { isBefore, isSameMonth, parse } from 'date-fns';
import { ECardType } from './config';
import { cardPatterns, expiration, routingNumber } from './regexp';

export const validateAchRouting = (value: string) => {
  if (value && !(String(value).match(routingNumber))) {
    return 'The value must contain 9 digits';
  }

  const obj = { 0: 3, 1: 7, 2: 1, 3: 3, 4: 7, 5: 1, 6: 3, 7: 7, 8: 1 };
  const digits = value.split('');
  const sum = digits.reduce(
    (accumulator: number, current: string, index: number) =>
      accumulator + Number(current) * (obj?.[index] ?? 1),
    0,
  );

  if (sum % 10 !== 0) {
    return 'Invalid routing format';
  }

  return true;
};

const luhnCheck = (cardNumber: string) => {
  let sum = 0;
  let shouldDouble = false; // We start from the right, so double every second digit

  // Loop through values from the end to the beginning
  for (let i = cardNumber.length - 1; i >= 0; i--) {
    let digit = parseInt(cardNumber.charAt(i));

    if (shouldDouble) {
      digit = digit * 2;
      if (digit > 9) {
        digit -= 9;
      }
    }

    sum += digit;
    shouldDouble = !shouldDouble; // Toggle the 'double' flag
  }

  return sum % 10 === 0;
};

export const validateCardNumber = (cardNumber: string, cardTypes: string[]) => {
  const cleaned = cardNumber.replaceAll(' ', '');

  if (new RegExp(cardPatterns[ECardType.PREDEFINED]).test(cleaned)) {
    return true;
  }

  const regexParts = cardTypes.map((type) => cardPatterns[type]);
  const regexString = `^(${regexParts.join(')$|^(')})$`;
  const pattern = new RegExp(regexString);

  if (pattern.test(cleaned)) {
    return luhnCheck(cleaned);
  }

  return `Please enter valid card number (${
    cardTypes
      .map((cardType) => cardType === ECardType.JCB ? cardType.toUpperCase() : cardType)
      .join(', ')
  })`;
};

export const validateExpirationDate = (value: string) => {
  const match = value && String(value).match(expiration);
  if (!(match) || !match?.length) {
    return 'Please enter valid expiration date';
  }

  const date = match[0].includes('/')
    ? parse(match[0], 'MM/yy', new Date())
    : parse(match[0], 'MMyy', new Date());

  if (isBefore(date, new Date()) && !isSameMonth(date, new Date())) {
    return 'Please enter valid expiration date';
  }

  return true;
};
